import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { makeObservable, override } from "mobx";
import StratumOrder from "../Models/Definition/StratumOrder";
function GetCapabilitiesMixin(Base) {
  var _class;
  let GetCapabilitiesMixin = (_class = class GetCapabilitiesMixin extends Base {
    constructor() {
      super(...arguments);
      makeObservable(this);
    }
    get getCapabilitiesUrl() {
      const getCapabilitiesUrl = super.getCapabilitiesUrl;
      if (getCapabilitiesUrl !== undefined) {
        return getCapabilitiesUrl;
      } else {
        return this.defaultGetCapabilitiesUrl;
      }
    }
  }, _applyDecoratedDescriptor(_class.prototype, "getCapabilitiesUrl", [override], Object.getOwnPropertyDescriptor(_class.prototype, "getCapabilitiesUrl"), _class.prototype), _class);
  return GetCapabilitiesMixin;
}
(function (_GetCapabilitiesMixin) {
  const getCapabilitiesStratumName = _GetCapabilitiesMixin.getCapabilitiesStratumName = "getCapabilities";
  StratumOrder.addLoadStratum(getCapabilitiesStratumName);
})(GetCapabilitiesMixin || (GetCapabilitiesMixin = {}));
export default GetCapabilitiesMixin;